// frontend/src/hooks/useDistanceCalculator.js
import { useCallback } from 'react';
import airportsData from '../data/airports.json';

const AIRPORTS_MAP = airportsData.airports;

const haversineDistanceNM = (lat1, lon1, lat2, lon2) => {
  const R = 3440; // Rayon de la Terre en NM
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

const useDistanceCalculator = () => {
  const getAirportCoordinates = useCallback((icao) => {
    const airport = AIRPORTS_MAP[icao?.toUpperCase()];
    if (!airport) return null;
    return {
      lat: airport.lat,      // ← CORRIGÉ : 'lat' au lieu de 'latitude'
      lon: airport.lon,      // ← CORRIGÉ : 'lon' au lieu de 'longitude'
      name: airport.name,
      city: airport.city
    };
  }, []);

  const calculateDistance = useCallback((departureIcao, destinationIcao) => {
    const departure = getAirportCoordinates(departureIcao);
    const destination = getAirportCoordinates(destinationIcao);
    
    if (!departure || !destination) {
      console.log('Airport not found:', { departureIcao, destinationIcao });
      return { distanceNM: null, error: 'Airport not found in database' };
    }
    
    const distanceNM = haversineDistanceNM(
      departure.lat, departure.lon,
      destination.lat, destination.lon
    );
    
    return {
      distanceNM: Math.round(distanceNM * 10) / 10,
      departure: { icao: departureIcao, ...departure },
      destination: { icao: destinationIcao, ...destination }
    };
  }, [getAirportCoordinates]);

  return { calculateDistance, getAirportCoordinates };
};

export default useDistanceCalculator;